import OurJourneyContainer from "../../../components/pages/other/OurJourney";

const OurJourney = () => {
  return <OurJourneyContainer />;
};

export default OurJourney;
